import { IQuiz } from '../IQuiz'

export const ocpAnti2: IQuiz = {
  name: 'ocp-anti-2',
  question: 'Как исправить проблему высокого зацепления модулей при связывании через конкретные классы?',
  variants: [
    {
      text: 'Связывать модули через абстракции, например, через интерфейсы'
    },
    {
      text: 'Использовать наследование, чтобы вынести общую логику в базовый класс',
      description:
        'Это не избавит от привязки к конкретному классу, просто на этот раз мы будем зависеть от конкретного родительского класса'
    },
    {
      text: 'Использовать шаблоны проектирования, которые уменьшают зацепление, например, декоратор или абстрактные фабрики'
    },
    {
      text: 'Использовать шаблоны синглтон или легковес, чтобы держать общее для объектов состояние отдельно',
      description: 'Это наоборот увеличит проблему высокого зацепления модулей'
    }
  ],
  meta: {
    correctAnswers: [0, 2]
  }
}
